import script from "./CatcoinIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CatcoinIcon.vue?vue&type=script&setup=true&lang=js"

import "./CatcoinIcon.vue?vue&type=style&index=0&id=54c59348&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c59348"]])

export default __exports__